import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.secondSection;

export default {
    title: textInfo.title,
    Subtitle: textInfo.Subtitle,
    describe: textInfo.describe,
    startBtn: textInfo.startBtn,
    timeYR: textInfo.timeYR,
    timeDAY: textInfo.timeDAY,
    timeHR: textInfo.timeHR,
    timeMIN: textInfo.timeMIN,
    timeSEC: textInfo.timeSEC,
    tiemr: textInfo.tiemr,
    startTime: textInfo.startTime,
    endTime: textInfo.endTime,
    viewDetailsBtn: textInfo.viewDetailsBtn
};
